import { render } from "./WCItemModifierCategoryGroup.vue?vue&type=template&id=769df029&scoped=true"
import script from "./WCItemModifierCategoryGroup.vue?vue&type=script&lang=js"
export * from "./WCItemModifierCategoryGroup.vue?vue&type=script&lang=js"

import "./WCItemModifierCategoryGroup.vue?vue&type=style&index=0&id=769df029&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769df029"]])

export default __exports__